import React, { useMemo } from "react";
import { Bell, LineChart, ShieldCheck, Users } from "lucide-react";
import EmpresaProductoProximamente from "../components/empresas/EmpresaProductoProximamente";
import { useEmpresasLanguage } from "../context/EmpresasLanguageContext";

const iconMap = {
  cotizacion: LineChart,
  cumplimiento: ShieldCheck,
  colaborador: Users,
  alertas: Bell,
};

function EmpresasGestionAportes() {
  const { t } = useEmpresasLanguage();

  const config = useMemo(
    () => ({
      ...t.gestionAportes,
      funcionalidades: t.gestionAportes.funcionalidades.map((item) => ({
        ...item,
        icon: iconMap[item.key],
      })),
    }),
    [t.gestionAportes]
  );

  return <EmpresaProductoProximamente config={config} />;
}

export default EmpresasGestionAportes;
